module.exports = __webpack_public_path__ + "img/mod-fatturazione-emt.7b57de94.png";